export const bitmap = [
  [
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
  ],
  [
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
  ],
  [
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
  ],
  [
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
  ],
  [
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
  ],
  [
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
  ],
  [
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
  ],
  [
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
  ],
  [
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
  ],
  [
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
  ],
  [
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
  ],
  [
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
  ],
  [
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
  ],
  [
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
  ],
  [
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
  ],
  [
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
  ],
  [
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
  ],
  [
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
  ],
  [
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
  ],
  [
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
  ],
  [
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
  ],
  [
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
  ],
  [
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
  ],
  [
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
  ],
  [
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
  ],
  [
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
  ],
  [
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
  ],
  [
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
  ],
  [
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
  ],
  [
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
  ],
  [
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
  ],
  [
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
  ],
];
